import { TFunction } from 'i18next';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createSelectors } from '../helpers';
import { uuid } from '@/helpers/common';

const TOOLTIP_REMOVE_TIMEOUT = 7000;

export enum TooltipTypes {
  SUCCESS,
  WARNING,
  INFO,
  ERROR,
}

interface BaseTooltipConfig {
  type: TooltipTypes;
  id?: string;
  animate?: boolean;
  removeTimeout?: number;
}

export interface TooltipConfig extends BaseTooltipConfig {
  body: React.ReactNode;
}

export interface TooltipConfigWithTranslation extends BaseTooltipConfig {
  body: ((t: TFunction) => string) | string;
  translate: boolean;
}

interface TooltipI extends BaseTooltipConfig {
  body: string | React.ReactNode;
  translate?: boolean;
}

export interface TooltipState {
  tooltip: TooltipI | undefined;

  show(config: TooltipConfigWithTranslation | TooltipConfig): void;

  remove: () => void;
}

const useTooltipStoreBase = create(
  immer<TooltipState>((set) => ({
    tooltip: undefined,

    show: ({
      type,
      body,
      id,
      animate = true,
      translate = false,
      removeTimeout = TOOLTIP_REMOVE_TIMEOUT,
    }: TooltipI) =>
      set({
        tooltip: {
          id: id == null ? uuid() : id,
          type,
          body,
          animate,
          translate,
          removeTimeout,
        },
      }),

    remove: () => set({ tooltip: undefined }),
  }))
);

export const useTooltipStore = createSelectors(useTooltipStoreBase);
